import ApiResourceManager from '../ApiResourceManager';

export default class ServiceProviderProfileManager extends ApiResourceManager {
  /**
   * Both endpoints act on the on-behalf-of service provider. Passing an
   * explicit id overrides the header derived from the sidebar selection, so
   * the Partners page can edit any partner without re-scoping the dashboard.
   */
  get = (serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: '/service-provider-profile',
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });

  update = (data, serviceProviderId = undefined) =>
    this.request({
      method: 'PUT',
      url: '/service-provider-profile',
      data,
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });
}
